export const ADD_BUNDLE = 'ADD_BUNDLE';

const bundle = (state = [], action) => {
  switch (action.type) {
    case 'ADD_BUNDLE':
      return action.data;
    default:
      return state;
  }
};

export default bundle;
